class Timeline {
    years;
    constructor() {
        this.years = $('.js-year');
        if (!this.years.length) return;
        $(window).on('scroll', this.checkPosition.bind(this));
        $(window).on('resize', this.checkPosition.bind(this));
        this.checkPosition();
    }

    checkPosition() {
        const windowTop = $(window).scrollTop();
        const windowHeight = $(window).height();
        const timelineTop = this.years.first().offset().top;
        let targetHeight = 0;
        this.years.each((index, element) => {
            const year = $(element);
            const offsetTop = year.offset().top;
            const elementHeight = year.outerHeight();

            if (offsetTop < windowTop + windowHeight / 2) {
                year.addClass('has-passed');
                targetHeight = (offsetTop + elementHeight - timelineTop) - 275 ;
            } else {
                year.removeClass('has-passed');
            }
        });

        this.years.first().css('--timeline-height', targetHeight + 'px');
    }
}

let timeline = new Timeline();
